import { formattedDateRange, subtractTime } from "src/js/util/dates";
import {
  HomeTrackComparablesFilterOptions,
  HMLRComparablesFilterOptions,
  LegacyComparablesFilterOptions,
} from "../typings/Comparables";
import {
  gatherConditions,
  possibleHometrackCombinations,
  possibleUKCombinations,
  possibleUSCombinations,
} from "./PropertyTypes";
import { HometrackDCSCondition } from "react-migration/lib/typings/comparables/Hometrack";
import { HMLRDCSCondition } from "react-migration/lib/typings/comparables/HMLR";
import Feature from "src/js/stores/user/Feature";
import hasFeature from "src/js/stores/user/actions/hasFeature";

export const getDefaultFilters = (): LegacyComparablesFilterOptions => {
  return {
    bedrooms: {
      min: undefined,
      max: undefined,
    },
    floorArea: {
      min: undefined,
      max: undefined,
    },
    dateFrom: formattedDateRange(subtractTime(new Date(), "months", 24)),
    dateTo: formattedDateRange(new Date()),
    designations: [],
    categories: [],
    subcategories: [],
    dcsConditions: hasFeature(Feature.usAccess)
      ? (possibleUSCombinations.flatMap(gatherConditions) as HMLRDCSCondition[])
      : (possibleUKCombinations.flatMap(gatherConditions) as HMLRDCSCondition[]),
    tenure: "Any",
    newBuildsOnly: false,
    yearBuiltFrom: undefined,
    yearBuiltTo: undefined,
  };
};

export const getDefaultHmlrFilters = (): HMLRComparablesFilterOptions => {
  return {
    floorArea: {
      min: undefined,
      max: undefined,
    },
    dateFrom: formattedDateRange(subtractTime(new Date(), "months", 36)),
    dateTo: formattedDateRange(new Date()),
    dcsConditions: hasFeature(Feature.usAccess)
      ? (possibleUSCombinations.flatMap(gatherConditions) as HMLRDCSCondition[])
      : (possibleUKCombinations.flatMap(gatherConditions) as HMLRDCSCondition[]),
    tenure: ["F", "L"],
    newBuildsOnly: false,
  };
};

export const defaultHometrackFilters: HomeTrackComparablesFilterOptions = {
  bedrooms: {
    min: undefined,
    max: undefined,
  },
  floorArea: {
    min: undefined,
    max: undefined,
  },
  dateFrom: formattedDateRange(subtractTime(new Date(), "months", 36)),
  dateTo: formattedDateRange(new Date()),
  dcsConditions: possibleHometrackCombinations.flatMap(gatherConditions) as HometrackDCSCondition[],
  tenure: ["F", "L", "S"],
  yearBuiltFrom: undefined,
  yearBuiltTo: undefined,
  onMarketOnly: false,
};
